import {Injectable} from '@angular/core';
import { Observable, timer } from 'rxjs';

@Injectable()
export class VgUtils {

      /**
   * 是否为MAC
   */
  static IsMac() {
    return /macintosh|mac os x/i.test(navigator.userAgent);
    }

    /**
     * Inspired by Paul Irish
     * https://gist.github.com/paulirish/211209
     * @returns {number}
     */
    static getZIndex():number {
        let zIndex = 1;
        let elementZIndex:number;

        let tags = document.getElementsByTagName('*');

        for (let i = 0, l = tags.length; i < l; i++) {
            elementZIndex = parseInt(window.getComputedStyle(tags[i])["z-index"], 10);

            if (elementZIndex > zIndex) {
                zIndex = elementZIndex + 1;
            }
        }

        return zIndex;
    }

    // Very simple mobile detection, not 100% reliable
    static isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf("IEMobile") !== -1);
    };
    static isSafari()
    {
        // console.log(navigator.vendor, "))))")
        // return navigator.vendor === "Apple Computer, Inc."

        // navigator.userAgent.toLowerCase().indexOf('safari/') > -1;

        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    }
    static isiOSDevice() {
        //alert(navigator.userAgent)
        return (navigator.userAgent.match(/ip(hone|ad|od)|CriOS/i) && !navigator.userAgent.match(/(iemobile)[\/\s]?([\w\.]*)/i));
    };

    static isCordova() {
        return document.URL.indexOf('http://') === -1 && document.URL.indexOf('https://') === -1;
    };
       ///是否使用浏览器内置全屏模式
       static shouldUseNative = true;

       static shouldHandleMouse = true;
       public static setTimeout(func, milsecond) {
        var subscript = timer(milsecond, 0).subscribe(p => {
            func();
            subscript.unsubscribe();
        });
        return subscript;
    }

    public static clearTimeout(subscript) {
        if (subscript) {
            subscript.unsubscribe();
        }
    }

    static openInNewWindow(url)
    {
        window.open(url,"_blank");
    }

    static isTouchDevice = false;
    ///是否使用伪全屏
    static shouldUseFakeFullScreen = false;

    static useFakeFullScreenWhenNotPossible = true;

}
